import { render, staticRenderFns } from "./EditClientFormCpt.vue?vue&type=template&id=70f1ac78&scoped=true&"
import script from "./EditClientFormCpt.vue?vue&type=script&lang=ts&"
export * from "./EditClientFormCpt.vue?vue&type=script&lang=ts&"
import style0 from "./EditClientFormCpt.vue?vue&type=style&index=0&id=70f1ac78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1ac78",
  null
  
)

export default component.exports